import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import tema from "../../services/Plantilla";
import { DefaultLayout } from '../../layout/theme-customizer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

const defaultLayout = Object.keys(DefaultLayout);
const layout = defaultLayout;

class Editar extends React.Component {
    constructor(props) {
        super(props);
        // INICIALIZAR STATE DENTRO DEL CONSTRUCTOR
        this.state = {
            load: '',
            datosCargados: false,
            usuario: {
                id: '',
                nombre: '',
                estado: '',
                icon: 'Folder',
                orden_mp: ''
            },
            errores: []
        };
    }

    cambioValor = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            usuario: {
                ...prevState.usuario,
                [name]: value
            }
        }));
    }

    verificarError = (elemento) => {
        return this.state.errores.includes(elemento);
    }

    enviarDatos = (e) => {
        e.preventDefault();
        const { usuario } = this.state;
        
        // INICIALIZAR CORRECTAMENTE EL ARRAY DE ERRORES
        const errores = [];

        // Convertir a string y validar
        const nombreStr = String(usuario.nombre || '');
        const iconStr = String(usuario.icon || '');
        const ordenMpStr = String(usuario.orden_mp || '');

        if (!nombreStr.trim()) { 
            errores.push("error_nombre"); 
        }
        if (usuario.estado === '' || usuario.estado === null || usuario.estado === undefined) { 
            errores.push("error_estado"); 
        }
        if (!iconStr.trim()) { 
            errores.push("error_icon"); 
        }
        if (!ordenMpStr.trim()) { 
            errores.push("error_orden_mp"); 
        }
        
        this.setState({ errores: errores });
        
        if (errores.length > 0) {
            Swal.fire({
                icon: 'error',
                title: 'Campos incompletos',
                text: 'Por favor complete todos los campos requeridos'
            });
            return false;
        }

        // Crear FormData
        const formData = new FormData();
        formData.append('id', usuario.id);
        formData.append('nombre', nombreStr.trim());
        formData.append('estado', usuario.estado);
        formData.append('icon', iconStr);
        formData.append('orden_mp', ordenMpStr.trim());

        authAxios.post("configuracion/editar", formData)
            .then((datosRespuesta) => {
                if (datosRespuesta.data?.Status || datosRespuesta.data?.status) {
                    Swal.fire({
                        title: '¡Éxito!',
                        text: datosRespuesta.data.msj || 'Registro actualizado exitosamente',
                        icon: 'success',
                        confirmButtonText: 'Aceptar'
                    }).then(() => {
                        window.location.href = `${process.env.PUBLIC_URL}/configuracion/lista/${tema}`;
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: datosRespuesta.data?.msj || 'Ocurrió un error al actualizar',
                        icon: 'error',
                        confirmButtonText: 'Aceptar'
                    });
                }
            })
            .catch((error) => {
                console.error('Error en la solicitud:', error);
                Swal.fire({
                    title: 'Error de conexión',
                    text: 'No se pudo conectar al servidor',
                    icon: 'error',
                    confirmButtonText: 'Aceptar'
                });
            });
    }

    componentDidMount() {
        Swal.showLoading();
        var ide = localStorage.getItem('ide');
        
        if (!ide) {
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se encontró el ID del registro'
            });
            window.location.href = `${process.env.PUBLIC_URL}/configuracion/lista/${tema}`;
            return;
        }

        authAxios.get(`configuracion/ver/${ide}`)
            .then((datosRespuesta) => {
                Swal.close();
                if (datosRespuesta.data) {
                    // Asegurarse de que todos los valores sean strings
                    this.setState({ 
                        datosCargados: true, 
                        usuario: {
                            id: datosRespuesta.data.id || '',
                            nombre: String(datosRespuesta.data.nombre || ''),
                            estado: datosRespuesta.data.estado?.toString() || '',
                            icon: String(datosRespuesta.data.icon || 'Folder'),
                            orden_mp: String(datosRespuesta.data.orden_mp || '')
                        },
                        load: '' 
                    });
                }
            })
            .catch((error) => {
                console.error('Error al cargar datos:', error);
                Swal.close();
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudieron cargar los datos del registro'
                });
            });
    }

    render() {
        const { load, usuario } = this.state;
        const iconOptions = [
            "Folder", "Home", "FolderPlus", "Cloud", "FileText", "Server",
            "Users", "ShoppingBag", "List", "Mail", "MessageCircle", "Monitor",
            "Clock", "Calendar", "CheckSquare", "Image", "Film", "Radio",
            "Map", "Edit", "Sunrise", "Activity", "Archive", "BarChart",
            "Book", "Briefcase"
        ];

        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>EDITAR MENÚ</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <input type="hidden" name="id" value={usuario.id} />
                                    
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="nombre">Nombre *</label>
                                                    <input 
                                                        type="text" 
                                                        name="nombre" 
                                                        id="nombre" 
                                                        value={usuario.nombre}
                                                        className={`form-control form-control-sm ${this.verificarError("error_nombre") ? "is-invalid" : ""}`} 
                                                        placeholder="Nombre" 
                                                        onChange={this.cambioValor}
                                                        autoComplete="off"
                                                    />
                                                    {this.verificarError("error_nombre") && (
                                                        <div className="invalid-feedback">Digite el nombre</div>
                                                    )}
                                                </div>
                                                
                                                <div className="col-md-2">
                                                    <label htmlFor="estado">Estado *</label>
                                                    <select 
                                                        name="estado"
                                                        id="estado"
                                                        value={usuario.estado}
                                                        className={`form-select form-select-sm ${this.verificarError("error_estado") ? "is-invalid" : ""}`}
                                                        onChange={this.cambioValor}
                                                    >
                                                        <option value="">Seleccione el Estado</option>
                                                        <option value="0">Activo</option>
                                                        <option value="1">Inactivo</option>
                                                    </select>
                                                    {this.verificarError("error_estado") && (
                                                        <div className="invalid-feedback">Seleccione el estado</div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-xl-12 mt-3">
                                            <div className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="icon">Icono *</label>
                                                    <select 
                                                        name="icon"
                                                        id="icon"
                                                        value={usuario.icon}
                                                        className={`form-select form-select-sm ${this.verificarError("error_icon") ? "is-invalid" : ""}`}
                                                        onChange={this.cambioValor}
                                                    >
                                                        {iconOptions.map((iconName, index) => (
                                                            <option key={index} value={iconName}>
                                                                {iconName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {this.verificarError("error_icon") && (
                                                        <div className="invalid-feedback">Seleccione un icono</div>
                                                    )}
                                                </div>
                                                
                                                <div className="col-md-2">
                                                    <label htmlFor="orden_mp">Orden en menú *</label>
                                                    <input 
                                                        style={{ textTransform: 'uppercase' }} 
                                                        type="text" 
                                                        name="orden_mp" 
                                                        id="orden_mp" 
                                                        value={usuario.orden_mp}
                                                        className={`form-control form-control-sm ${this.verificarError("error_orden_mp") ? "is-invalid" : ""}`} 
                                                        placeholder="Orden" 
                                                        onChange={this.cambioValor}
                                                        autoComplete="off"
                                                    />
                                                    {this.verificarError("error_orden_mp") && (
                                                        <div className="invalid-feedback">Digite el orden</div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <hr />
                                    <div className='row mt-3'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm">
                                                    <FontAwesomeIcon icon={faSave} />&nbsp;&nbsp; Actualizar menú
                                                </button>&nbsp;&nbsp;
                                                <Link 
                                                    className="btn btn-danger btn-sm" 
                                                    to={`${process.env.PUBLIC_URL}/configuracion/lista/${tema}`}
                                                >
                                                    <FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="card-footer text-muted">
                                <small>Los campos marcados con * son obligatorios</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;